import { get, post } from '@/utils/request'
import {  postOcr } from '@/utils/requestOcr'
import {  postTTS } from '@/utils/requestTTS'
import {  postChat } from '@/utils/requestChat'
/**
 * 获取token
 * @param {*} data 
 * @returns 
 */
export function getToken(data) {
  return post('/auth/token', data)
}

/**
 * 获取阿里云签名
 * @returns 
 */
export function getAliyunSigned(){
  return get(`/aliyun/signed/?url=${process.env.VUE_APP_BASE_API}/`)
}

/**
 * ocrAliyunByBlob
 * @returns 
 */
export function ocrAliyunByBlob(data){
  return postOcr('aliyun/ocr',data)
}

/**
 * 获取所有产品
 * @param {*} data 
 * @returns 
 */
export function getProductList(){
  return get('product/all')
}

/**
 * 根据产品id获取视频文件
 * @param {*} data 
 * @returns 
 */
export function getMaterialType(id){
  return get(`material/?material_type=video&product_id=${id}`)
}



/**
 * 获取所有产品
 * @param {*} data 
 * @returns 
 */
export function getProductAllList(data){
  return get(`product/all?keyword=${data.keyword}&skip=${data.skip}&limit=${data.limit}&code=${data.code}`)
}



/**
 * 上报扫码
 * @param {*} data 
 * @returns 
 */
export function productRecognition(data){
  return post(`/product/recognition`,data)
}



/**
 * 聊天授权
 * @param {*} data 
 * @returns 
 */
export function getAuthInfo(data){
  return postChat(`/qa/security/token/apiAuth`,data)
}


/**
 * 发起聊天
 * @param {*} data 
 * @returns 
 */
export function chatByText(data){
  // console.log(data)
  return postChat(`/qa/server/qa/question`,data)
}
